import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

export type GlobalSearchResultType =
  | 'engineer'
  | 'team'
  | 'repository'
  | 'pull_request'
  | 'work_item';

export interface GlobalSearchHit {
  type: GlobalSearchResultType;
  id: string;
  label: string;
  description?: string;
  path: string;
}

interface GlobalSearchResponse {
  results: GlobalSearchHit[];
}

export function useGlobalSearch(
  organizationId: string | undefined,
  query: string,
  options?: { enabled?: boolean }
) {
  const trimmed = query.trim();
  const safe = trimmed.replace(/[%_\\]/g, '').trim();

  const allowRemote = options?.enabled !== false;

  return useQuery({
    queryKey: ['global-search', organizationId, safe],
    queryFn: async () => {
      const params = new URLSearchParams({ q: safe });
      const data = await apiClient.get<GlobalSearchResponse>(
        `organizations/${organizationId}/search?${params.toString()}`
      );
      return data.results;
    },
    enabled: allowRemote && Boolean(organizationId && safe.length >= 2),
    staleTime: 30_000,
  });
}
